module.exports = __webpack_public_path__ + "static/media/icon-10.af49445f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-10.png
// module id = 2567
// module chunks = 0